(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6302],{

/***/ 93:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/biz",
      function () {
        return __webpack_require__(8734);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ biz; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/autoplay/autoplay.min.css
var autoplay_min = __webpack_require__(5519);
// EXTERNAL MODULE: ./src/cds/styles.ts
var styles = __webpack_require__(3887);
;// CONCATENATED MODULE: ./src/components/biz/section1.tsx



function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding-bottom: 3.6rem;\n  & > strong {\n    font-size: 2.4rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 1.6rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  color: white;\n  background-color: ",
        ";\n  padding: 1.6rem 6rem;\n  white-space: nowrap;\n  border-radius: 0.4rem;\n  font-size: 1.6rem;\n  font-weight: bold;\n  margin: 0 auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 3;\n  width: auto;\n  padding-left: 2rem;\n  padding-right: 2rem;\n  color: #000;\n  padding-top: 12rem;\n  padding-bottom: 12rem;\n  * {\n    color: #fff;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n  background-color: rgba(0, 0, 0, 0.8);\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  position: relative;\n  & > picture > img {\n    object-fit: cover;\n    height: 100%;\n    width: 100%;\n  }\n  & > picture {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1;\n    overflow: hidden;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
var Section1 = function(param) {
    var onClickButton = param.onClickButton;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(L_Section1, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(L_Section1Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(L_Section1_T, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                            children: [
                                "기업 성장에 날개를 달아주는 임직원 교육,",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "클래스유에서 시작하세요."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(L_Section1_B, {
                        children: [
                            "직무 교육부터 자기 계발을 위한 교육, 법정교육까지",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "임직원의 성장이 기업의 성장으로 연결됩니다.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(L_Section1_B_Btn, {
                        onClick: onClickButton,
                        children: "기업교육 문의하기"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(L_Section1Backdrop, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "biz-banner.png",
                    alt: "",
                    loading: "lazy"
                })
            })
        ]
    }));
};
var L_Section1_T = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-6e888734-0"
})(_templateObject());
var L_Section1_B = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-6e888734-1"
})(_templateObject1());
var L_Section1_B_Btn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-6e888734-2"
})(_templateObject2(), styles/* palette.Primary.Active */.DG.Primary.Active);
var L_Section1Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6e888734-3"
})(_templateObject3());
var L_Section1Backdrop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6e888734-4"
})(_templateObject4());
var L_Section1 = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-6e888734-5"
})(_templateObject5());
/* harmony default export */ var section1 = (Section1);

;// CONCATENATED MODULE: ./src/components/biz/section2.tsx



function section2_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function section2_templateObject() {
    var data = section2_taggedTemplateLiteral([
        "\n  width: auto;\n  padding-left: 2rem;\n  padding-right: 2rem;\n  color: #000;\n  @media (min-width: 1280px) {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  @media (min-width: 960px) {\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 0;\n    padding-right: 0;\n    max-width: 98rem;\n  }\n\n  @media (min-width: 1024px) {\n    width: 100%;\n    margin: 0 auto;\n    max-width: 98rem;\n  }\n"
    ]);
    section2_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function section2_templateObject1() {
    var data = section2_taggedTemplateLiteral([
        "\n  padding-top: 10rem;\n  padding-bottom: 4rem;\n  @media (min-width: 1024px) {\n    width: 100%;\n    margin: 0 auto;\n    max-width: 98rem;\n  }\n  & > div {\n    font-weight: 700;\n    color: inherit;\n    max-width: 98rem;\n    padding-bottom: 1.8rem;\n    font-size: 2.4rem;\n    text-align: center;\n    color: ",
        ";\n  }\n"
    ]);
    section2_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Section2 = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(L_Section2Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(L_Section2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: "클래스유 Biz와 함께 성장하는 고객사"
                })
            })
        })
    }));
};
var L_Section2Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9797c0eb-0"
})(section2_templateObject());
var L_Section2 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9797c0eb-1"
})(section2_templateObject1(), styles/* palette.grey75 */.DG.grey75);
/* harmony default export */ var section2 = (Section2);

;// CONCATENATED MODULE: ./src/components/biz/section3.tsx



function section3_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function section3_templateObject() {
    var data = section3_taggedTemplateLiteral([
        "\n  padding-top: 0rem;\n  padding-bottom: 7rem;\n  text-align: center;\n  font-size: 1.6rem;\n  color: ",
        ";\n"
    ]);
    section3_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Section3 = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(L_Section3Container, {
            children: [
                "200여 개의 기업이 클래스유를 통해",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "임직원에 교육을 제공하고 있습니다."
            ]
        })
    }));
};
var L_Section3Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f1686c08-0"
})(section3_templateObject(), styles/* palette.grey50 */.DG.grey50);
/* harmony default export */ var section3 = (Section3);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 88 modules
var swiper_esm = __webpack_require__(2544);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(2546);
;// CONCATENATED MODULE: ./src/components/biz/section4.tsx





function section4_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function section4_templateObject() {
    var data = section4_taggedTemplateLiteral([
        "\n  padding-bottom: 6rem;\n"
    ]);
    section4_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function section4_templateObject1() {
    var data = section4_taggedTemplateLiteral([
        "\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n"
    ]);
    section4_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function section4_templateObject2() {
    var data = section4_taggedTemplateLiteral([
        "\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n        "
    ]);
    section4_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function section4_templateObject3() {
    var data = section4_taggedTemplateLiteral([
        "\n  height: 6rem;\n  object-fit: contain;\n  width: fit-content;\n  ",
        ";\n"
    ]);
    section4_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function section4_templateObject4() {
    var data = section4_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n\n  z-index: 2;\n  width: 10rem;\n  @media (max-width: 1024px) {\n    display: none;\n  }\n"
    ]);
    section4_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function section4_templateObject5() {
    var data = section4_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n\n  z-index: 2;\n  width: 10rem;\n  @media (max-width: 1024px) {\n    display: none;\n  }\n"
    ]);
    section4_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = section4_taggedTemplateLiteral([
        "\n  .swiper-wrapper {\n    transition-timing-function: linear;\n  }\n  display: flex;\n  max-width: 1024px;\n  margin: 0 auto;\n  position: relative;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
var logos = [
    {
        src: '/new/biz/logos/logo1.png'
    },
    {
        src: '/new/biz/logos/logo2.png'
    },
    {
        src: '/new/biz/logos/logo3.png'
    },
    {
        src: '/new/biz/logos/logo4.png'
    },
    {
        src: '/new/biz/logos/logo5.png'
    },
    {
        src: '/new/biz/logos/logo6.png'
    },
    {
        src: '/new/biz/logos/logo7.png'
    },
    {
        src: '/new/biz/logos/logo8.png'
    },
    {
        src: '/new/biz/logos/logo9.png'
    },
    {
        src: '/new/biz/logos/logo10.png'
    },
    {
        src: '/new/biz/logos/logo11.png'
    }, 
];
var Section4 = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(L_Section4Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RollingBanner, {})
    }));
};
var L_Section4Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-47a504b1-0"
})(section4_templateObject());
var RollingBanner = function() {
    var ref = (0,react.useState)(960), width = ref[0], setWidth = ref[1];
    var isMobile = (0,react.useMemo)(function() {
        return width <= 1024;
    }, [
        width
    ]);
    (0,react.useEffect)(function() {
        var callback = function() {
            setWidth(window.outerWidth);
        };
        callback();
        window.addEventListener('resize', callback);
        return function() {
            window.removeEventListener('resize', callback);
        };
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(L_RollingBanner, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                spaceBetween: 50,
                slidesPerView: isMobile ? 2 : 3,
                autoplay: {
                    delay: 0,
                    stopOnLastSlide: false
                },
                speed: 3000,
                allowTouchMove: false,
                loop: true,
                modules: [
                    swiper_esm/* Autoplay */.pt
                ],
                children: [
                    logos,
                    logos,
                    logos,
                    logos,
                    logos,
                    logos
                ].flat(1).map(function(param, i) {
                    var src = param.src;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RollingBannerImage, {
                                    src: src,
                                    alt: src
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RollingBannerAbsoluteWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RollingBannerImage, {
                                        isShow: true,
                                        src: src,
                                        alt: src
                                    })
                                })
                            ]
                        })
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackdropRight, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackdropLeft, {})
        ]
    }));
};
var RollingBannerAbsoluteWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-47a504b1-1"
})(section4_templateObject1());
var RollingBannerImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-47a504b1-2"
})(section4_templateObject3(), function(param) {
    var isShow = param.isShow;
    return isShow ? (0,styled_components_browser_esm/* css */.iv)(section4_templateObject2()) : 'opacity:0';
});
var BackdropRight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-47a504b1-3"
})(section4_templateObject4());
var BackdropLeft = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-47a504b1-4"
})(section4_templateObject5());
var L_RollingBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-47a504b1-5"
})(_templateObject6());
/* harmony default export */ var section4 = (Section4);

;// CONCATENATED MODULE: ./src/components/biz/section5.tsx



function section5_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function section5_templateObject() {
    var data = section5_taggedTemplateLiteral([
        "\n  margin-bottom: 4rem;\n"
    ]);
    section5_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function section5_templateObject1() {
    var data = section5_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 1.6rem;\n"
    ]);
    section5_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function section5_templateObject2() {
    var data = section5_taggedTemplateLiteral([
        "\n  font-weight: 700;\n  color: inherit;\n  font-size: 2.4rem;\n  color: ",
        ";\n  margin-bottom: 4rem;\n"
    ]);
    section5_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function section5_templateObject3() {
    var data = section5_taggedTemplateLiteral([
        "\n  background: ",
        ";\n  padding-top: 8rem;\n  padding-bottom: 8rem;\n  text-align: center;\n"
    ]);
    section5_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function section5_templateObject4() {
    var data = section5_taggedTemplateLiteral([
        "\n  max-width: calc(2 * 30rem);\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  margin: 0 auto;\n  @media (max-width: 768px) {\n    padding: 0 3rem;\n    row-gap: 3rem;\n    grid-template-columns: 1fr;\n  }\n"
    ]);
    section5_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
var Section5 = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(L_Section5, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(L_Section5_T, {
                    children: "클래스유는 다릅니다."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(L_Section5_B, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(L_Section5_B_Contents, {
                        children: [
                            "170만의 회원에게 직접 검증받은 데이터를 토대로",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "기업에 도움이 되는 콘텐츠를 제공합니다."
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(L_DiffIcons, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://classu-files.s3.ap-northeast-2.amazonaws.com/image/1847901/2024-03-25/10%3A25%3A38/image-removebg-preview_(1).png",
                            alt: "clu_system"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://classu-files.s3.ap-northeast-2.amazonaws.com/image/1847901/2024-03-25/10%3A25%3A48/image-removebg-preview.png",
                            alt: "clu_system"
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var section5 = (Section5);
var L_Section5_B = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8a60343f-0"
})(section5_templateObject());
var L_Section5_B_Contents = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-8a60343f-1"
})(section5_templateObject1(), styles/* palette.grey50 */.DG.grey50);
var L_Section5_T = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-8a60343f-2"
})(section5_templateObject2(), styles/* palette.grey75 */.DG.grey75);
var L_Section5 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8a60343f-3"
})(section5_templateObject3(), styles/* palette.system.BLACK */.DG.system.BLACK);
var L_DiffIcons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8a60343f-4"
})(section5_templateObject4());

;// CONCATENATED MODULE: ./src/components/biz/section6.tsx



function section6_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function section6_templateObject() {
    var data = section6_taggedTemplateLiteral([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    section6_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function section6_templateObject1() {
    var data = section6_taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    section6_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function section6_templateObject2() {
    var data = section6_taggedTemplateLiteral([
        "\n  margin: 10rem auto 0 auto;\n  padding: 0 2rem;\n  text-align: center;\n  font-size: 1.6rem;\n  & > div > img {\n    max-width: 107rem;\n    object-fit: cover;\n    width: 100%;\n  }\n"
    ]);
    section6_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var Section6 = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(L_Section4, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    bold: true,
                    fontSize: "2.4rem",
                    children: "클래스유에는 모든 교육이 다 있습니다."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    marginTop: '4rem'
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Span, {
                        strong: true,
                        children: "실무에 바로 써먹을 수 있는 직무 콘텐츠부터"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Span, {
                        strong: true,
                        children: "삶의 질 향상을 돕는 자기 계발 강의와 법정교육까지!"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    marginTop: '2rem'
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Span, {
                        children: "기업에 꼭 필요한 "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Span, {
                        strong: true,
                        children: "클래스유만의 6만 여개의 콘텐츠"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Span, {
                        children: "로"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Span, {
                        children: "임직원이 한 층 더 성장합니다."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    margin: ' 6rem auto 0 auto'
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    style: {
                        maxWidth: '74.5rem'
                    },
                    src: "https://classu-files.s3.ap-northeast-2.amazonaws.com/image/1847901/2024-03-25/10%3A28%3A20/lectures.png",
                    alt: "banner"
                })
            })
        ]
    }));
};
var Span = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-b50310fc-0"
})(section6_templateObject(), function(param) {
    var strong = param.strong, bold = param.bold;
    return bold ? 600 : strong ? 500 : 300;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize ? fontSize : '1.6rem';
}, styles/* palette.grey50 */.DG.grey50);
var Title = (0,styled_components_browser_esm/* default */.ZP)(Span).withConfig({
    componentId: "sc-b50310fc-1"
})(section6_templateObject1(), styles/* palette.grey75 */.DG.grey75);
var L_Section4 = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-b50310fc-2"
})(section6_templateObject2());
/* harmony default export */ var section6 = (Section6); /* 기업에 꼭 필요한 클래스유만의 6만 여개의 콘텐츠로 임직원이 한 층 더 성장합니다. */  // position: absolute;
 // width: 451px;
 // height: 64px;
 // left: 244px;
 // top: 1538px;
 // font-family: 'S-Core Dream';
 // font-style: normal;
 // font-weight: 300;
 // font-size: 20px;
 // line-height: 157.9%;
 // /* or 32px */
 // text-align: center;
 // /* 1d1d1d */
 // color: #1D1D1D;

;// CONCATENATED MODULE: ./src/components/biz/section7.tsx



function section7_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function section7_templateObject() {
    var data = section7_taggedTemplateLiteral([
        "\n  text-align: center;\n  margin-top: 8rem;\n  background: ",
        ";\n  font-size: 1.6rem;\n  font-weight: 300;\n  padding: 3rem 2rem 0 2rem;\n  & > div {\n    color: ",
        ";\n  }\n  & > div > button {\n    color: white;\n    background-color: ",
        ";\n    padding: 1rem 3rem;\n    white-space: nowrap;\n    border-radius: 0.5rem;\n    font-weight: 600;\n    margin: 3.6rem auto 0 auto;\n    font-size: 1.6rem;\n  }\n  padding-bottom: 3rem;\n"
    ]);
    section7_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function section7_templateObject1() {
    var data = section7_taggedTemplateLiteral([
        "\n  font-size: 2.4rem;\n  font-weight: 600;\n  color: ",
        ";\n"
    ]);
    section7_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Section7 = function(param) {
    var onClickButton = param.onClickButton;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(L_Section7, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Strong, {
                children: "궁금하신 클래스가 있다면 문의를 남겨주세요."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    marginTop: '1rem'
                },
                children: "상담 후 체험용 계정을 전달드립니다."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: onClickButton,
                    children: "기업교육 문의하기"
                })
            })
        ]
    }));
};
var L_Section7 = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-3934cb06-0"
})(section7_templateObject(), styles/* palette.system.BLACK */.DG.system.BLACK, styles/* palette.grey50 */.DG.grey50, styles/* palette.Primary.Active */.DG.Primary.Active);
var Strong = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-3934cb06-1"
})(section7_templateObject1(), styles/* palette.grey75 */.DG.grey75);
/* harmony default export */ var section7 = (Section7);

;// CONCATENATED MODULE: ./src/components/biz/section8.tsx



function section8_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function section8_templateObject() {
    var data = section8_taggedTemplateLiteral([
        "\n  margin-top: 4rem;\n  & > span {\n    font-weight: 300;\n    font-size: 1.6rem;\n    color: ",
        ";\n  }\n"
    ]);
    section8_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function section8_templateObject1() {
    var data = section8_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  & > strong {\n    font-size: 2.4rem;\n    font-weight: 600;\n  }\n"
    ]);
    section8_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function section8_templateObject2() {
    var data = section8_taggedTemplateLiteral([
        "\n  padding-top: 10rem;\n  * {\n    text-align: center;\n    white-space: nowrap;\n  }\n"
    ]);
    section8_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var Section8 = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(L_Section6, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(section8_Strong, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "각 분야 최고의 강사님들을"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "만날 수 있습니다."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Mid, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "기업 교육 전문 강사부터"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "컨설턴트, 현직에 있는 실무자까지"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "모두 클래스유에 있습니다."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    margin: '5rem 0 0 0'
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    style: {
                        maxWidth: '66rem',
                        width: '100%'
                    },
                    src: "/new/biz/logos/section6.png",
                    alt: "teachers"
                })
            })
        ]
    }));
};
var Mid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-790ccc48-0"
})(section8_templateObject(), styles/* palette.grey50 */.DG.grey50);
var section8_Strong = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-790ccc48-1"
})(section8_templateObject1(), styles/* palette.grey75 */.DG.grey75);
var L_Section6 = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-790ccc48-2"
})(section8_templateObject2());
/* harmony default export */ var section8 = (Section8);

;// CONCATENATED MODULE: ./src/components/biz/section9.tsx



function section9_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function section9_templateObject() {
    var data = section9_taggedTemplateLiteral([
        "\n  margin: 0 auto;\n  background-color: ",
        ";\n  padding-top: 10rem;\n  padding: 10rem 2rem 0 2rem;\n  text-align: center;\n  & > span {\n    font-weight: 600;\n    font-size: 2.4rem;\n    color: ",
        ";\n  }\n"
    ]);
    section9_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function section9_templateObject1() {
    var data = section9_taggedTemplateLiteral([
        "\n  padding: 6rem 2rem 6rem 2rem;\n  display: flex;\n  flex-wrap: nowrap;\n  overflow-x: scroll;\n  column-gap: 4rem;\n  & > img {\n    width: 28rem;\n    margin-top: 2rem;\n  }\n  margin: 0 -2rem 0 -2rem;\n\n  /* 280 * 5 : 이미지 너비 * 이미지 개수 */\n  /* 40 * 4 : 이미지 간격 * 간격수 */\n  /* 40 * 2 : 양 옆 패딩 */\n\n  @media (min-width: 1640px) {\n    justify-content: center;\n    padding: 6rem 2rem 6rem 2rem;\n    margin: 0 auto;\n  }\n"
    ]);
    section9_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Section9 = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(L_Section9, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "기업과 임직원의 목적과 방향성에 맞춰"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "서비스를 제공합니다."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/new/biz/logos/후기1.png",
                        alt: "후기1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/new/biz/logos/후기2.png",
                        alt: "후기2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/new/biz/logos/후기3.png",
                        alt: "후기3"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/new/biz/logos/후기4.png",
                        alt: "후기4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/new/biz/logos/후기5.png",
                        alt: "후기5"
                    })
                ]
            })
        ]
    }));
};
var L_Section9 = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-ae11835f-0"
})(section9_templateObject(), styles/* palette.BTN.BG */.DG.BTN.BG, styles/* palette.grey75 */.DG.grey75);
var ImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ae11835f-1"
})(section9_templateObject1());
/* harmony default export */ var section9 = (Section9);

;// CONCATENATED MODULE: ./src/components/biz/section10.tsx



function section10_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function section10_templateObject() {
    var data = section10_taggedTemplateLiteral([
        "\n  text-align: center;\n"
    ]);
    section10_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function section10_templateObject1() {
    var data = section10_taggedTemplateLiteral([
        "\n  font-weight: 600;\n  font-size: 2.4rem;\n  margin-top: 10rem;\n  color: ",
        ";\n"
    ]);
    section10_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function section10_templateObject2() {
    var data = section10_taggedTemplateLiteral([
        "\n  margin-top: 3.2rem;\n"
    ]);
    section10_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function section10_templateObject3() {
    var data = section10_taggedTemplateLiteral([
        "\n  font-weight: 300;\n  font-size: 1.6rem;\n  color: ",
        ";\n"
    ]);
    section10_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var Section10 = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(section10_L_Section6, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(L_Section6_T_Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "무료로 상담받고,"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "클래스유에서 고민을 해결하세요."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(L_Section6_B_ContentContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(L_Section6_B_Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "문의를 남겨주시면,"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "가능한 빠르게 연락드리겠습니다."
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var section10 = (Section10);
var section10_L_Section6 = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-6eb498bc-0"
})(section10_templateObject());
var L_Section6_T_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6eb498bc-1"
})(section10_templateObject1(), styles/* palette.grey75 */.DG.grey75);
var L_Section6_B_ContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6eb498bc-2"
})(section10_templateObject2());
var L_Section6_B_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6eb498bc-3"
})(section10_templateObject3(), styles/* palette.grey50 */.DG.grey50);

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/cds/forms/CheckBox.tsx
var CheckBox = __webpack_require__(6838);
// EXTERNAL MODULE: ./src/components/atoms/common/SpinLoading.js
var SpinLoading = __webpack_require__(5734);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(3935);
// EXTERNAL MODULE: ./src/cds/icons/index.tsx
var icons = __webpack_require__(6643);
;// CONCATENATED MODULE: ./src/components/biz/section11.tsx











function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent, args, Class) {
    if (isNativeReflectConstruct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function section11_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function section11_templateObject() {
    var data = section11_taggedTemplateLiteral([
        "\n  width: max-content;\n  margin-left: auto;\n  background-color: #eb5149;\n  border-radius: 0.5rem;\n  & > button {\n    padding: 0.5rem 2rem;\n    font-weight: 600;\n    font-size: 1.6rem;\n    color: #fff;\n  }\n"
    ]);
    section11_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function section11_templateObject1() {
    var data = section11_taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: left;\n  margin-top: 3rem;\n  span {\n    color: ",
        ";\n  }\n  & > label > span {\n    top: 0.3rem !important;\n  }\n  & > div {\n    margin-top: 1rem;\n  }\n  & > div > span {\n    font-size: 1.6rem;\n    font-weight: 300;\n  }\n  & > div > span:nth-of-type(1) {\n    margin-left: 3.2rem;\n    font-size: 1.6rem;\n    font-weight: 300;\n  }\n  & > div > a {\n    font-size: 1.6rem;\n    font-weight: 300;\n    text-decoration: underline;\n    color: ",
        ";\n  }\n\n  & > label > span {\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    section11_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function section11_templateObject2() {
    var data = section11_taggedTemplateLiteral([
        "\n  margin: 0 auto;\n  max-width: 437px;\n  width: calc(100% - 3rem);\n  padding-bottom: 12rem;\n  * {\n    text-align: left;\n  }\n"
    ]);
    section11_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function section11_templateObject3() {
    var data = section11_taggedTemplateLiteral([
        "\n  width: 100%;\n  resize: none;\n  height: 55rem;\n  padding: 1.6rem;\n  outline: none;\n  height: 30rem;\n  border: 1px solid ",
        ";\n  font-weight: 300;\n  font-size: 1.6rem;\n  padding: 0.5rem 1rem;\n  background-color: ",
        ";\n  color: ",
        ";\n"
    ]);
    section11_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function section11_templateObject4() {
    var data = section11_taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 0.4rem;\n  font-size: 1.6rem;\n  outline: none;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  color: ",
        ";\n"
    ]);
    section11_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function section11_templateObject5() {
    var data = section11_taggedTemplateLiteral([
        "\n  text-align: left;\n  font-weight: 300;\n  font-size: 1.6rem;\n  margin-bottom: 1rem;\n  color: ",
        ";\n"
    ]);
    section11_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function section11_templateObject6() {
    var data = section11_taggedTemplateLiteral([
        "\n  width: 100%;\n  font-weight: 300;\n  font-size: 1.6rem;\n  padding: 0.5rem 1rem;\n  border: 1px solid ",
        ";\n  outline: none;\n  background-color: ",
        ";\n  color: ",
        ";\n"
    ]);
    section11_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = section11_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  text-align: left;\n  margin-top: 3rem;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = section11_taggedTemplateLiteral([
        "\n  transition: all 0.8s;\n  opacity: ",
        ";\n  max-height: ",
        ";\n  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);\n  transform: translateX(\n    ",
        "\n  );\n  background-color: #fff;\n  border-radius: 16px;\n  padding: 2rem 4rem;\n  font-size: 1.6rem;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = section11_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  opacity: 0.4;\n  cursor: pointer;\n\n  ",
        " {\n    &:hover {\n      opacity: 1;\n    }\n  }\n\n  &:active {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = section11_taggedTemplateLiteral([
        "\n    0% { opacity:0 }\n    100% { opacity:1 }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = section11_taggedTemplateLiteral([
        "\n    0% { opacity:1 }\n    100% { opacity:0 }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = section11_taggedTemplateLiteral([
        "\n          animation: ",
        " ",
        "ms;\n        "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = section11_taggedTemplateLiteral([
        "\n          animation: ",
        " ",
        "ms;\n        "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = section11_taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, ",
        ");\n  z-index: 200;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
var Section11 = /*#__PURE__*/ (0,react.forwardRef)(function(_, ref) {
    var name = useInput();
    var company = useInput();
    var email = useInput();
    var contact = useInput();
    var ref1 = (0,react.useState)('10명 이하'), companySize = ref1[0], setCompanySize = ref1[1];
    var ref2 = (0,react.useState)(false), check = ref2[0], setCheck = ref2[1];
    var ref3 = (0,react.useState)(''), content = ref3[0], setContent = ref3[1];
    var onChangeContent = (0,react.useCallback)(function(e) {
        setContent(e.target.value);
    }, []);
    var resetFormValues = (0,react.useCallback)(function() {
        name.setInput('');
        company.setInput('');
        email.setInput('');
        contact.setInput('');
        setCompanySize('10명 이하');
        setCheck(false);
        setContent('');
    }, [
        company,
        contact,
        email,
        name
    ]);
    var onToast = useToast().onToast;
    var ref4 = (0,react.useState)(false), isLoading = ref4[0], setIsLoading = ref4[1];
    var ref5 = (0,react.useState)(false), isSuccess = ref5[0], setIsSuccess = ref5[1];
    var onCloseSuccessModal = (0,react.useCallback)(function() {
        return setIsSuccess(false);
    }, []);
    var onSubmit = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (name.input) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", onToast('성함을 입력해주세요'));
                case 2:
                    if (company.input) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return", onToast('기업명을 입력해주세요'));
                case 4:
                    if (email.input) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return", onToast('이메일 주소를 입력해주세요'));
                case 6:
                    if (contact.input) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", onToast('연락처를 입력해주세요'));
                case 8:
                    if (check) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", onToast('개인정보 수집/이용에 동의해주세요'));
                case 10:
                    if (content) {
                        _ctx.next = 12;
                        break;
                    }
                    return _ctx.abrupt("return", onToast('문의 내용을 입력해주세요'));
                case 12:
                    _ctx.prev = 12;
                    setIsLoading(true);
                    data = {
                        성함: name.input,
                        기업명: company.input,
                        이메일주소: email.input,
                        연락처: contact.input,
                        기업인원: companySize,
                        문의내용: content
                    };
                    _ctx.next = 17;
                    return axios_default().post('/new/api/biz/slack', data);
                case 17:
                    setIsSuccess(true);
                    resetFormValues();
                    _ctx.next = 25;
                    break;
                case 21:
                    _ctx.prev = 21;
                    _ctx.t0 = _ctx["catch"](12);
                    onToast('오류가 발생하였습니다.\n다시 시도해주세요.');
                    if (false) {}
                case 25:
                    _ctx.prev = 25;
                    setIsLoading(false);
                    return _ctx.finish(25);
                case 28:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                12,
                21,
                25,
                28
            ]
        ]);
    })), [
        name.input,
        company.input,
        email.input,
        contact.input,
        check,
        content,
        onToast,
        companySize,
        resetFormValues, 
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalLoading, {
                isLoading: isLoading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessModal, {
                isSuccess: isSuccess,
                onCloseSuccessModal: onCloseSuccessModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(L_Section7Form, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(L_Section7FormInputContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(L_Section7FormInputLabel, {
                                children: "성함"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(L_Section7FormInput, {
                                value: name.input,
                                onChange: name.onChangeInput
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(L_Section7FormInputContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(L_Section7FormInputLabel, {
                                children: "기업명"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(L_Section7FormInput, {
                                value: company.input,
                                onChange: company.onChangeInput
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(L_Section7FormInputContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(L_Section7FormInputLabel, {
                                children: "이메일 주소"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(L_Section7FormInput, {
                                value: email.input,
                                onChange: email.onChangeInput
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(L_Section7FormInputContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(L_Section7FormInputLabel, {
                                children: "연락처"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(L_Section7FormInput, {
                                value: contact.input,
                                onChange: contact.onChangeInput
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(L_Section7FormInputContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(L_Section7FormInputLabel, {
                                children: "기업인원"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(L_Section7FormSelect, {
                                value: companySize,
                                onChange: function(e) {
                                    setCompanySize(e.target.value);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        children: "10명 이하"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        children: "50명 이하"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        children: "100명 이하"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        children: "300명 이하"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        children: "500명 이하"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        children: "500명 이상"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(L_Section7FormInputContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(L_Section7FormInputLabel, {
                                children: "문의 내용"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(L_Section7FormTextarea, {
                                value: content,
                                onChange: onChangeContent
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckBoxContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* default */.Z, {
                                checked: check,
                                // @ts-ignore
                                onChange: function(e) {
                                    setCheck(e.target.checked);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "[필수] "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        target: "_blank",
                                        rel: "noreferrer noopener",
                                        href: "https://www.classu.co.kr/new/customer/agreement",
                                        children: "개인정보 수집/ 이용"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "에 동의합니다."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: onSubmit,
                            children: "문의하기"
                        })
                    })
                ]
            })
        ]
    }));
});
var ButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-912ca0d5-0"
})(section11_templateObject());
var CheckBoxContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-912ca0d5-1"
})(section11_templateObject1(), styles/* palette.grey25 */.DG.grey25, styles/* palette.grey25 */.DG.grey25, styles/* palette.BTN.BG */.DG.BTN.BG, styles/* palette.grey0 */.DG.grey0);
var L_Section7Form = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-912ca0d5-2"
})(section11_templateObject2());
Section11.displayName = 'form';
/* harmony default export */ var section11 = (Section11);
var useInput = function() {
    var ref = (0,react.useState)(''), input = ref[0], setInput = ref[1];
    var onChangeInput = (0,react.useCallback)(function(e) {
        setInput(e.target.value);
    }, []);
    return {
        input: input,
        onChangeInput: onChangeInput,
        setInput: setInput
    };
};
var L_Section7FormTextarea = styled_components_browser_esm/* default.textarea.withConfig */.ZP.textarea.withConfig({
    componentId: "sc-912ca0d5-3"
})(section11_templateObject3(), styles/* palette.system.Null */.DG.system.Null, styles/* palette.BTN.BG */.DG.BTN.BG, styles/* palette.grey0 */.DG.grey0);
var L_Section7FormSelect = styled_components_browser_esm/* default.select.withConfig */.ZP.select.withConfig({
    componentId: "sc-912ca0d5-4"
})(section11_templateObject4(), styles/* palette.system.Null */.DG.system.Null, styles/* palette.BTN.BG */.DG.BTN.BG, styles/* palette.grey0 */.DG.grey0);
var L_Section7FormInputLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-912ca0d5-5"
})(section11_templateObject5(), styles/* palette.grey25 */.DG.grey25);
var L_Section7FormInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-912ca0d5-6"
})(section11_templateObject6(), styles/* palette.system.Null */.DG.system.Null, styles/* palette.BTN.BG */.DG.BTN.BG, styles/* palette.grey0 */.DG.grey0);
var L_Section7FormInputContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-912ca0d5-7"
})(_templateObject7());
var useToast = function() {
    var portalEle = (0,react.useRef)(null);
    var toastContainer = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var isDefined = customElements.get('classu-portal');
        if (!isDefined) {
            var ClassuPortalClass = /*#__PURE__*/ function(HTMLElement) {
                "use strict";
                _inherits(ClassuPortalClass, HTMLElement);
                var _super = _createSuper(ClassuPortalClass);
                function ClassuPortalClass() {
                    _classCallCheck(this, ClassuPortalClass);
                    return _super.call(this);
                }
                return ClassuPortalClass;
            }(_wrapNativeSuper(HTMLElement));
            customElements.define('classu-portal', ClassuPortalClass);
        }
    }, []);
    // return createPortal(children, portalEle.current);
    var onToast = (0,react.useCallback)(function(str) {
        if (false) {}
        if (!portalEle.current || !document.getElementById('toast-container')) {
            var portalContainer = document.createElement('classu-portal');
            portalContainer.style.position = 'fixed';
            portalContainer.style.top = '10%';
            portalContainer.style.left = '50%';
            portalContainer.style.transform = 'translateX(-50%)';
            portalEle.current = portalContainer;
            document.body.appendChild(portalEle.current);
        }
        if (!toastContainer.current || !document.getElementById('toast-container')) {
            toastContainer.current = document.createElement('div');
            toastContainer.current.id = 'toast-container';
            toastContainer.current.style.display = 'flex';
            toastContainer.current.style.flexDirection = 'column-reverse';
            toastContainer.current.style.rowGap = '8px';
            portalEle.current.appendChild(toastContainer.current);
        }
        var curToastContainer = document.createElement('div');
        toastContainer.current.appendChild(curToastContainer);
        if (toastContainer.current.childNodes.length > 10) {
            toastContainer.current.removeChild(toastContainer.current.firstElementChild);
        }
        react_dom.render(/*#__PURE__*/ (0,jsx_runtime.jsx)(Toast, {
            text: str
        }), curToastContainer);
        setTimeout(function() {
            console.log(toastContainer.current.firstChild);
            if (toastContainer.current.childNodes.length === 1) {
                portalEle.current.remove();
            } else {
                toastContainer.current.removeChild(toastContainer.current.firstElementChild);
            }
        }, 2500);
    }, []);
    return {
        onToast: onToast
    };
};
var Toast = function(param) {
    var text = param.text;
    var ref = (0,react.useState)(false), mount = ref[0], setMount = ref[1];
    var ref6 = (0,react.useState)(false), exit = ref6[0], setExit = ref6[1];
    (0,react.useEffect)(function() {
        setMount(true);
        setTimeout(function() {
            setMount(false);
            setExit(true);
        }, 2000);
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ToastContainer, {
        exit: exit,
        isMount: mount,
        children: text
    }));
};
var ToastContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-912ca0d5-8"
})(_templateObject8(), function(param) {
    var isMount = param.isMount;
    return isMount ? 1 : 0;
}, function(param) {
    var isMount = param.isMount;
    return isMount ? '100vh' : '0px';
}, function(param) {
    var isMount = param.isMount, exit = param.exit;
    return !exit && isMount ? '0' : exit ? '10vw' : '-10vw';
});
var ClassuPortal = function(param) {
    var children = param.children;
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    var portalEle = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var isDefined = customElements.get('classu-portal');
        if (!isDefined) {
            var ClassuPortalClass = /*#__PURE__*/ function(HTMLElement) {
                "use strict";
                _inherits(ClassuPortalClass, HTMLElement);
                var _super = _createSuper(ClassuPortalClass);
                function ClassuPortalClass() {
                    _classCallCheck(this, ClassuPortalClass);
                    return _super.call(this);
                }
                return ClassuPortalClass;
            }(_wrapNativeSuper(HTMLElement));
            customElements.define('classu-portal', ClassuPortalClass);
        }
        setMounted(true);
        portalEle.current = document.createElement('classu-portal');
        document.body.appendChild(portalEle.current);
        return function() {
            if (portalEle.current != null) {
                document.body.removeChild(portalEle.current);
            }
        };
    }, []);
    if (!mounted || portalEle.current == null) {
        return null;
    }
    return(/*#__PURE__*/ (0,react_dom.createPortal)(children, portalEle.current));
};
var DURATION = 500;
var SuccessModal = function(param) {
    var isSuccess = param.isSuccess, onCloseSuccessModal = param.onCloseSuccessModal;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    (0,react.useEffect)(function() {
        if (isSuccess) {
            return setOpen(true);
        }
        setTimeout(function() {
            setOpen(false);
        }, DURATION - 50);
    }, [
        isSuccess
    ]);
    if (!open) {
        return null;
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ClassuPortal, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(L_GlobalLoading, {
            onClick: onCloseSuccessModal,
            open: open && isSuccess,
            backgroundOpacity: 0.3,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: function(e) {
                    e.stopPropagation();
                },
                style: {
                    backgroundColor: '#FFF',
                    padding: '4rem',
                    borderRadius: '1rem',
                    position: 'relative'
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            position: 'absolute',
                            right: 0,
                            top: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                            onClick: onCloseSuccessModal,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                name: "ic_close_m",
                                width: "16",
                                height: "16",
                                fill: styles/* palette.black */.DG.black
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            fontSize: '2rem',
                            textAlign: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "문의가 정상적으로 접수되었습니다"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "클래스유에서 곧 연락드리겠습니다"
                            })
                        ]
                    })
                ]
            })
        })
    }));
};
var CloseButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-912ca0d5-9"
})(_templateObject9(), styles/* onlyHover */.kC);
var GlobalLoading = function(param) {
    var isLoading = param.isLoading;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    (0,react.useEffect)(function() {
        if (isLoading) {
            return setOpen(true);
        }
        setTimeout(function() {
            setOpen(false);
        }, DURATION - 50);
    }, [
        isLoading
    ]);
    if (!open) {
        return null;
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ClassuPortal, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(L_GlobalLoading, {
            open: open && isLoading,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpinLoading/* default */.Z, {})
        })
    }));
};
var fadeIn = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject10());
var fadeOut = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject11());
var L_GlobalLoading = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-912ca0d5-10"
})(_templateObject14(), function(param) {
    var backgroundOpacity = param.backgroundOpacity;
    return backgroundOpacity !== null && backgroundOpacity !== void 0 ? backgroundOpacity : 0.7;
}, function(param) {
    var open = param.open;
    return open ? (0,styled_components_browser_esm/* css */.iv)(_templateObject12(), fadeIn, DURATION) : (0,styled_components_browser_esm/* css */.iv)(_templateObject13(), fadeOut, DURATION);
});

;// CONCATENATED MODULE: ./pages/biz/index.tsx
















function biz_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function biz_templateObject() {
    var data = biz_taggedTemplateLiteral([
        ""
    ]);
    biz_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function biz_templateObject1() {
    var data = biz_taggedTemplateLiteral([
        "\n\thtml,\n\tbody {\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tfont-size: 10px;\n\t}\n\n\thtml {\n\t\tmin-height: 100%;\n\t}\n\n\tbody {\n\t\tmin-height: 100%;\n\t}\n\n\t* {\n\t\tfont: inherit;\n\t\tfont-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Roboto', 'Segoe UI', sans-serif;\n\t\tcolor: #1d1d1d;\n\t\t-webkit-tap-highlight-color: transparent;\n\t\t-webkit-box-sizing: border-box;\n\t\t-moz-box-sizing: border-box;\n\t\tbox-sizing: border-box;\n\n\t\t&::before,\n\t\t&::after {\n\t\t\t-webkit-box-sizing: inherit;\n\t\t\t-moz-box-sizing: inherit;\n\t\t\tbox-sizing: inherit;\n\t\t}\n\t}\n\n\tarticle,\n\taside,\n\tdetails,\n\tfigcaption,\n\tfigure,\n\theader,\n\thgroup,\n\tmenu,\n\tNav,\n\tsection {\n\t\tdisplay: block;\n\t}\n\n\ttable {\n\t\tborder-collapse: collapse;\n\t\tborder-spacing: 0;\n\t}\n\n\tbutton {\n\t\tpadding: 0;\n\t\tbackground-color: rgba(0, 0, 0, 0);\n\t\toutline: none;\n\t\tborder: 0;\n\t\tcursor: pointer;\n\t}\n\n\tdd {\n\t\t-webkit-margin-start: 0;\n\t}\n\n\tul {\n\t\t-webkit-padding-start: 0;\n\t\tlist-style-position: inside;\n\t\tmargin: 0;\n\t}\n\n\tli,\n\tol,\n\tul {\n\t\tlist-style: none;\n\t}\n\n\ta {\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\tfont-size: 100%;\n\t\ttext-decoration: none;\n\t\tcolor: inherit;\n\t\tbackground: rgba(0, 0, 0, 0);\n\t\tcursor: pointer;\n\t}\n\n\timg {\n\t\tmax-width: 100%;\n\t}\n\n\tb,\n\tspan {\n\t\tfont-size: inherit;\n\t\tcolor: inherit;\n\t\tfont-weight: inherit;\n\t}\n\n\tstrong {\n\t\tfont-size: inherit;\n\t\tfont-weight: bold;\n\t\tcolor: inherit;\n\t}\n\n\tbr {\n\t\tline-height: inherit;\n\t}\n\n\tfooter {\n\t\tpadding: 0;\n\t}\n\n\tinput,\n\ttextarea {\n\t\tfont-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Roboto', 'Segoe UI', sans-serif;\n\t\tpadding: 0;\n\t\tappearance: none;\n\t}\n\n\th1,\n\th2,\n\th3,\n\th4,\n\th5,\n\th6 {\n\t\tmargin: 0;\n\t\tfont-weight: 400;\n\t}\n\n\tdialog {\n\t\tdisplay: block;\n\t\tpadding: 0;\n\t\tborder: none;\n\t\tbackground: inherit;\n\t}\n\n\t.preventHighlight {\n\t\t-webkit-tap-highlight-color: transparent;\n\t}\n\n\t.noselect {\n\t\t-webkit-touch-callout: none;\n\t\t-webkit-user-select: none;\n\t\t-khtml-user-select: none;\n\t\t-moz-user-select: none;\n\t\t-ms-user-select: none;\n\t\tuser-select: none;\n\t}\n\n\tp {\n\t\tmargin: 0;\n\t}\n\n\ti {\n\t\tfont-style: normal;\n\t}\n\n\t::selection {\n\t\tbackground-color: #000;\n\t\tcolor: #fff;\n\t}\n\n\thtml.webview, body.webview {\n\t\theight: 100%;\n\t}\n\n\t.emoji {\n\t\tletter-spacing: 0;\n    margin-right: 0.5rem;\n\t}\n"
    ]);
    biz_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var BizIntroduce = function() {
    var ref1 = (0,react.useRef)(null);
    var onClickButton = (0,react.useCallback)(function() {
        var ref;
        (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            behavior: 'smooth'
        });
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyles, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(section1, {
                        onClickButton: onClickButton
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(section2, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(section3, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(section4, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(section5, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(section6, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(section7, {
                        onClickButton: onClickButton
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(section8, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(section9, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(section10, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(section11, {
                        ref: ref1
                    })
                ]
            })
        ]
    }));
};
var MainContainer = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
    componentId: "sc-91f017a-0"
})(biz_templateObject());
/* harmony default export */ var biz = (BizIntroduce);
var GlobalStyles = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(biz_templateObject1());


/***/ }),

/***/ 6838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7379);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3887);


// styles

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  position: relative;\n  padding-left: 28px;\n  font-size: 14px;\n  line-height: 20px;\n  color: ",
        ";\n  user-select: none;\n  cursor: pointer;\n\n  ",
        " {\n    &:hover input ~ span {\n      background: ",
        ";\n    }\n  }\n\n  &:active input ~ span {\n    background: ",
        ";\n\n    @media (hover: hover) {\n      background: ",
        ";\n      border: 1px solid ",
        ";\n    }\n  }\n\n  input {\n    position: absolute;\n    opacity: 0;\n    height: 0;\n    width: 0;\n    cursor: pointer;\n\n    &:checked ~ span {\n      background: ",
        ";\n      border: 1px solid ",
        ";\n    }\n\n    &:checked ~ span::after {\n      opacity: 1;\n    }\n\n    &:disabled ~ span {\n      border: 1px solid ",
        ";\n    }\n  }\n\n  span {\n    position: absolute;\n    top: -1px;\n    left: 0;\n    height: 22px;\n    width: 22px;\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    border-radius: 2px;\n    transition: background 0.1s ease, border 0.1s ease;\n\n    &::after {\n      content: '';\n      position: absolute;\n      left: 6px;\n      top: 2px;\n      width: 8px;\n      height: 12px;\n      border: 1px solid ",
        ";\n      border-width: 0 2px 2px 0;\n      opacity: 0;\n      transform: rotate(45deg);\n      transition: opacity 0.1s ease;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
/**
 * 체크박스
 * @param props
 * @param props.label 라벨 (id)
 * @param props.message 체크박스 메세지
 * @param props.checked 체크 여부
 * @param props.disabled 비활성화 여부
 *
 * @example
 * <CheckBox
 *   name="체크박스명"
 *   label="라벨명"
 *   message="로그인 상태 유지"
 * />
 */ var CheckBox = function(_param) {
    var label = _param.label, message = _param.message, checked = _param.checked, disabled = _param.disabled, props = _objectWithoutProperties(_param, [
        "label",
        "message",
        "checked",
        "disabled"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Label, {
        htmlFor: label,
        disabled: disabled,
        children: [
            message,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({
                id: label,
                type: "checkbox",
                checked: checked,
                disabled: disabled
            }, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
        ]
    }));
};
var Label = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-c7451c6d-0"
})(_templateObject(), function(props) {
    return props.disabled ? cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.font.tertiary2 */ .DG.font.tertiary2 : cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.font.tertiary1 */ .DG.font.tertiary1;
}, cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .onlyHover */ .kC, cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.grey010 */ .DG.grey010, cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.grey010 */ .DG.grey010, function(props) {
    return props.disabled ? cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.white */ .DG.white : cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.red040 */ .DG.red040;
}, function(props) {
    return props.disabled ? cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.grey030 */ .DG.grey030 : cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.red040 */ .DG.red040;
}, cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.red040 */ .DG.red040, cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.red040 */ .DG.red040, cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.grey030 */ .DG.grey030, cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.white */ .DG.white, cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.grey040 */ .DG.grey040, cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.white */ .DG.white);
/* harmony default export */ __webpack_exports__["Z"] = (CheckBox);


/***/ }),

/***/ 5734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7379);
/* harmony import */ var lib_styles_animations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1751);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3887);


// styles


function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  margin: 0px auto;\n  width: ",
        ";\n\n  &:before {\n    content: '';\n    display: block;\n    padding-top: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  animation: ",
        " 1.6s linear infinite;\n  height: 100%;\n  transform-origin: center center;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  stroke: ",
        ";\n  stroke-width: 4;\n  stroke-miterlimit: 10;\n  stroke-dasharray: 1, 200;\n  stroke-dashoffset: 0;\n  stroke-linecap: round;\n  fill: none;\n  animation: ",
        " 1.2s ease-in-out infinite;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
/**
 * 로딩
 * @param {object} props
 * @param {number} props.size
 * @param {string} props.color
 */ var SpinLoading = function(param) {
    var _size = param.size, size = _size === void 0 ? 36 : _size, _color = param.color, color = _color === void 0 ? cds_styles__WEBPACK_IMPORTED_MODULE_2__/* .palette.red040 */ .DG.red040 : _color;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Loader, {
        size: size,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Svg, {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "25 25 50 50",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CirclePath, {
                cx: "50",
                cy: "50",
                r: "20",
                color: color
            })
        })
    }));
};
var Loader = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b538cb9d-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return "".concat(size, "px");
});
var Svg = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].svg.withConfig */ .ZP.svg.withConfig({
    componentId: "sc-b538cb9d-1"
})(_templateObject1(), lib_styles_animations__WEBPACK_IMPORTED_MODULE_1__/* .spin */ .O2);
var CirclePath = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].circle.withConfig */ .ZP.circle.withConfig({
    componentId: "sc-b538cb9d-2"
})(_templateObject2(), function(param) {
    var color = param.color;
    return color;
}, lib_styles_animations__WEBPACK_IMPORTED_MODULE_1__/* .dashLoad */ .tG);
/* harmony default export */ __webpack_exports__["Z"] = (SpinLoading);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6736,9774,2888,179], function() { return __webpack_exec__(93); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);